// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2mM8o","empty":"ModalGraph_empty__1tPbZ"};